import type { ChartDataPoint } from "./types";

type RawChartPoint = { dt: string; sum: number };

export function mapChartPoints(raw: RawChartPoint[]): ChartDataPoint[] {
	return raw.map(({ dt, sum }) => ({ date: dt, value: sum }));
}
